import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { AddChat, ChatItem, Menu } from './components';

const Wrapper = styled.div`
  width: ${(props) => (props.isMobile ? '100vw' : '376px')};
  border-right: 1px solid ${theme.GREY_20};
  height: 100%;
`;

const Scrollable = styled.div`
  width: 100%;
  height: calc(100% - 72px);
  overflow-y: scroll;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const ChatList = ({ data, selectedChat, setSelectedChat, updateFilters, filters }) => {
  const [showFilters, setShowFilters] = useState(false),
    [showAddChat, setShowAddChat] = useState(false),
    user = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    navigate = useNavigate(),
    { t } = useTranslation();

  let totalMessageCount = 0;

  for (var x of data) {
    totalMessageCount += x.users.find((x) => x.user._id === user._id).notifCount;
  }

  function handleSelect(item) {
    setShowFilters(false);
    setSelectedChat(item);
  }

  return (
    <Wrapper isMobile={isMobile}>
      <Row ht="71px" wid="100%" borderBottom={`1px solid ${theme.GREY_20}`}>
        <Col noFlex pad="0 16px" wid="100%" ht="100%">
          <Row wid="100%" center between>
            <Text h4>
              {t(
                totalMessageCount !== 1
                  ? 'messages.totalMessages'
                  : 'messages.totalMessageSingular',
                { totalMessageCount }
              )}
            </Text>

            {showFilters && (
              <Menu
                visible={showFilters}
                setVisible={setShowFilters}
                updateFilters={updateFilters}
                filters={filters}
              />
            )}

            {showAddChat && (
              <AddChat setSelectedChat={handleSelect} handleClose={() => setShowAddChat(false)} />
            )}

            <Row gap="16px" center>
              <Clickable onClick={() => setShowAddChat(!showFilters)}>
                <Icon type="addChat" dimensions={20} col={theme.GREY_50} />
              </Clickable>

              <Clickable onClick={() => setShowFilters(!showFilters)}>
                <Icon type="filter" dimensions={16} col={theme.GREY_50} />
              </Clickable>
            </Row>
          </Row>
        </Col>
      </Row>

      <Scrollable>
        {!!data.length ? (
          data.map((x, i) => (
            <ChatItem
              item={x}
              key={i}
              setSelectedChat={handleSelect}
              selected={selectedChat === x._id}
              user={user}
              navigate={navigate}
            />
          ))
        ) : (
          <Col pad="16px 0 0" centerAll>
            <Text h4 col={theme.GREY_50}>
              {t('messages.noChats')}
            </Text>
          </Col>
        )}
      </Scrollable>
    </Wrapper>
  );
};

export default ChatList;
